import { Linkedin, Twitter, Facebook, MessageCircle, Mail, Link2, Share2 } from "lucide-react";
import { toast } from "sonner";

export default function ShareBar({ url, title, text, compact = false }) {
  const link = url || (typeof window !== "undefined" ? window.location.href : "");
  const headline = title || "Oak AI Campus · Master anything";
  const body = text || "I just levelled up with Oak AI Campus — try it.";

  const buttons = [
    { name: "LinkedIn", Icon: Linkedin, color: "text-[#0A66C2]", href: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(link)}` },
    { name: "X", Icon: Twitter, color: "text-white", href: `https://twitter.com/intent/tweet?text=${encodeURIComponent(body)}&url=${encodeURIComponent(link)}` },
    { name: "Facebook", Icon: Facebook, color: "text-[#1877F2]", href: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(link)}` },
    { name: "WhatsApp", Icon: MessageCircle, color: "text-[#25D366]", href: `https://wa.me/?text=${encodeURIComponent(body + " " + link)}` },
    { name: "Email", Icon: Mail, color: "text-white/80", href: `mailto:?subject=${encodeURIComponent(headline)}&body=${encodeURIComponent(body + "\n\n" + link)}` },
  ];

  const webShare = async () => {
    try {
      if (navigator.share) {
        await navigator.share({ title: headline, text: body, url: link });
      } else {
        await navigator.clipboard.writeText(link);
        toast.success("Link copied");
      }
    } catch {}
  };

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(link);
      toast.success("Link copied");
    } catch {
      toast.error("Copy failed");
    }
  };

  return (
    <div className={`flex items-center flex-wrap gap-2 ${compact ? "" : "p-4 glass !rounded-2xl"}`} data-testid="share-bar">
      {buttons.map(({ name, Icon, color, href, onClick }) => (
        <a
          key={name}
          href={href}
          onClick={onClick}
          target="_blank"
          rel="noreferrer"
          className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs border border-white/10 hover:border-white/30 bg-white/[0.03] hover:bg-white/10 transition ${color}`}
          data-testid={`share-${name.toLowerCase()}`}
        >
          <Icon size={13} /> {name}
        </a>
      ))}
      <button
        onClick={webShare}
        className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs btn-mint-outline"
        data-testid="share-native"
      >
        <Share2 size={13} /> More
      </button>
      <button
        onClick={copy}
        className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs border border-white/10 hover:border-white/20 text-white/70 transition"
        data-testid="share-copy"
      >
        <Link2 size={13} /> Copy
      </button>
    </div>
  );
}
